import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class ProjectTaggingService {
  constructor(private http: HttpClient) {}

  loadProjects(baseUrl: string, globalService: any, filterParams: any = {}, rowData: any = {}): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    const params: any = _.merge({}, globalService || {}, filterParams || {});
    params.action_code = 'hp3vyj';
    params.tax_year = rowData?.TAX_YEAR ?? params.tax_year;
    params.scenario = rowData?.SCENARIO ?? params.scenario;
    params.jcd_key = rowData?.JCD_KEY ?? params.jcd_key;

    return this.http.get<any>(url, { params, withCredentials: true });
  }

  loadProjectSteps(
    baseUrl: string,
    projectId: any,
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    const params: any = _.merge({}, globalService || {}, filterParams || {});
    params.action_code = 'rvqx3d';
    params.project_id = projectId;
    params.tax_year = rowData?.TAX_YEAR ?? params.tax_year;
    params.scenario = rowData?.SCENARIO ?? params.scenario;
    params.jcd_key = rowData?.JCD_KEY ?? params.jcd_key;

    return this.http.get<any>(url, { params, withCredentials: true });
  }

  saveProjectTag(
    baseUrl: string,
    payload: any[],
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=tdbs7c`;
    const params: any = _.merge({}, globalService || {}, filterParams || {});

    params.jsonObj = JSON.stringify(payload || []);
    params.tax_year = rowData?.TAX_YEAR ?? params.tax_year;
    params.scenario = rowData?.SCENARIO ?? params.scenario;
    params.jcd_key = rowData?.JCD_KEY ?? params.jcd_key;

    const checkLockedbj = (payload || []).map((row: any) => ({
      leid: row?.LEID ?? rowData?.LEID ?? '',
      cdr_number: row?.CDR_NO ?? rowData?.CDR_NO ?? rowData?.MARS ?? '',
      consol_group_key: String(rowData?.CONSOL_GROUP_KEY ?? ''),
      reporting_period: String(rowData?.REPORTING_PERIOD ?? ''),
      combination_key: String(row?.COMBINATION_KEY ?? rowData?.COMBINATION_KEY ?? ''),
      scenario_key: parseInt(String(params.scenario ?? rowData?.SCENARIO ?? 0), 10) || 0
    }));
    params.checkLockedbj = JSON.stringify(checkLockedbj);

    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach((key: string) => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }
}
